import { render, staticRenderFns } from "./Achievement.vue?vue&type=template&id=21ba0180&scoped=true"
import script from "./Achievement.vue?vue&type=script&lang=js"
export * from "./Achievement.vue?vue&type=script&lang=js"
import style0 from "./Achievement.vue?vue&type=style&index=0&id=21ba0180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ba0180",
  null
  
)

export default component.exports